import { HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import ConfigJson from '../../../config.json';
import { NotificationService } from '../services/notification.service';

let versionDialogShown = false;

export const versionInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const notificationService = inject(NotificationService);

  return next(req).pipe(
    tap((event) => {
      if (versionDialogShown || !(event instanceof HttpResponse)) {
        return;
      }

      const serverVersion = event.headers.get('X-App-Version');
      if (!serverVersion) {
        return;
      }

      if (serverVersion !== ConfigJson.version) {
        versionDialogShown = true;
        notificationService.showVersionDialog().subscribe(() => {
          window.location.reload();
        });
      }
    })
  );
};
